export default "__VITE_ASSET__BqiPk_w2__"